module.exports = __webpack_public_path__ + "static/media/Sstrom.8d5deced.png";